import { Component, Input, Output, EventEmitter } from "@angular/core";

import { FormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { LucideAngularModule, Send, Paperclip } from "lucide-angular";

@Component({
  selector: "app-message-input",
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    LucideAngularModule
],
  template: `
    <div class="relative">
      <div class="flex justify-end gap-2">
        <mat-form-field class="relative w-full">
          <input
            matInput
            type="text"
            [(ngModel)]="message"
            (ngModelChange)="messageChange.emit($event)"
            (keydown)="onEnterPress($event)"
            [placeholder]="placeholder"
            [disabled]="disabled"
          />
          <mat-hint align="end">{{ message.length }}/2000</mat-hint>
          <button
            matSuffix
            (click)="onSend()"
            [disabled]="!message.trim() || disabled"
            class="p-2 !mr-2 rounded-md bg-light-primary dark:bg-dark-primary text-white hover:bg-light-primary-variant dark:hover:bg-dark-primary-variant disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 flex-shrink-0"
            [attr.aria-label]="'Send message'"
          >
            <lucide-angular [img]="Send" class="w-4 h-4"></lucide-angular>
          </button>
        </mat-form-field>
      </div>
    </div>
  `,
})
export class MessageInputComponent {
  @Input() message = "";
  @Input() placeholder = "Type a message...";
  @Input() disabled = false;
  @Output() messageChange = new EventEmitter<string>();
  @Output() sendMessage = new EventEmitter<void>();

  readonly Send = Send;
  readonly Paperclip = Paperclip;

  onEnterPress(event: any): void {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.onSend();
    }
  }

  onSend(): void {
    if (this.message.trim()) {
      this.sendMessage.emit();
    }
  }
}
